import React from "react";
import { Modal, Fade, Box, Typography, Button } from "@mui/material";
import { Save, Cancel } from "@mui/icons-material";

export const CustomModal = ({
  open = false,
  title = "Guardar cambios",
  text = "¿Desea guardar los cambios realizados?",
  txtBtn1 = "Guardar",
  funBtn1 = () => {},
  txtBtn2 = "Cancelar",
  funBtn2 = () => {},
  iconBtn1 = <Save />,
  iconBtn2 = <Cancel />,
  btnDisabled = false,
  segundoBtn = true,
  colorbtn2 = "error",
}) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      // onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Box
          sx={{
            ...style.modal,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: 2,
          }}
        >
          <Typography
            id="transition-modal-title"
            variant="h4"
            sx={style.modal_title}
            color="primary"
            fontWeight={900}
            style={{ marginBottom: 10 }}
          >
            {title}
          </Typography>
          <Typography
            variant="h6"
            sx={{ textAlign: "center" }}
            color="secondary.dark"
          >
            {text}
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={segundoBtn ? { marginRight: 7 } : {}}
              // sx={{ marginRight: 7 }}
              // Poner el icono en base a la propiedad iconBtn1
              startIcon={iconBtn1}
              onClick={funBtn1}
              disabled={btnDisabled}
            >
              {txtBtn1}
            </Button>
            {segundoBtn && (
              <Button
                variant="contained"
                color={colorbtn2}
                startIcon={iconBtn2}
                onClick={funBtn2}
                disabled={btnDisabled}
              >
                {txtBtn2}
              </Button>
            )}
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
  },
};
